// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Vue from "vue";
// import VueI18n from 'vue-i18n';
// import LanguageData from "./language/index"; //中文最终汇总暴露的信息
// import VueI18n from "vue-i18n";
import App from "./App";
import global_msg from "./global.js"; //注意文件路径，实际路径以项目目录结构为准
import router from "./router";
import htmlToPdf from './utils/htmlToPdf'
Vue.use(htmlToPdf)


Vue.config.productionTip = false;
Vue.use(Element);
Vue.prototype.$global_msg = global_msg;
// import Swiper from 'swiper';
// import '../node_modules/swiper/dist/css/swiper.css';
// Vue.use(Swiper);


// Vue.use(VueI18n) // 挂载
// const i18n = new VueI18n({
//   locale: localStorage.getItem("languageSet") || "CN", //从localStorage里获取用户中英文选择，没有则默认中文
//   messages: {
//     CN: LanguageData.CN,
//     EN: LanguageData.EN
//   }
// });
// const i18n = new VueI18n({
//   locale: 'zh-CN',    // 语言标识
//   messages: {
//     'zh-CN': require('./lang/zh'),   // 通过require引入中文语言包
//     'en-US': require('./lang/en')    // 通过require引入英文语言包
//   }
// })
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  // i18n,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js